import Polyglot from '../libs/polyglot';

function createLocaleShortcut() {
  window.__ = (function () {
    const poly = new Polyglot({ phrases: window.lang });

    return poly.t.bind(poly);
  }());
}

createLocaleShortcut();
